import BaseModel from './BaseModel';

class CsDiagnostics extends BaseModel {
  constructor(data = {}) {
    super(data);
    this.updateData(data)
  }

  updateData = (data) => {
    this.id = data.id;
    this.charging_station = data.charging_station || [];
    this.start_date = data.start_date || "";
    this.end_date = data.end_date || "";
  }

  toApiJson = () => {
    this.completeValidation();
    return {
      cs_diagonostics: {
        device_id: this.charging_station[this.charging_station.length-1].device_id,
        start_date: this.start_date.length < 17 ? (this.start_date).split('T').join(' ') + ":00" : (this.start_date).split('T').join(' '),
        end_date: this.end_date.length < 17 ? (this.end_date).split('T').join(' ') + ":00" : (this.end_date).split('T').join(' '),
      }
    }
  }

  validations = (field) => {
    return {
      charging_station: () => {
        if (this[field].length === 0) {
          this.errors.charging_station = "Select Charging Station";
        } else {
          delete this.errors.charging_station;
        }
      },
      start_date: () => {
        if(this[field] === "") {
          this.errors.start_date = "This field is required.";
        } else {
          if(this.end_date && this[field] > this.end_date) {
            this.errors.start_date = "End date must be greater than start date";
          } else {
            delete this.errors.start_date;
          }
        }
      },
      end_date: () => {
        if(this[field] === "") {
          this.errors.end_date = "This field is required.";
        } else {
          if(this.start_date && this[field] < this.start_date) {
            this.errors.end_date = "Start date must be smaller than end date";
          } else {
            delete this.errors.end_date;
          }
        }
      },
    }[field];
  }

  validate = (field) => {
    if (this.validations(field)) {
      this.validations(field)();
    }
  }
}

export default CsDiagnostics;
